import { render, staticRenderFns } from "./CreateExam.vue?vue&type=template&id=7efde3b0&lang=pug&"
import script from "./CreateExam.vue?vue&type=script&lang=js&"
export * from "./CreateExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports